import React from "react";
import { cn } from "./cn";
import { SearchIcon } from "../../../assets/ui/icons";

/* The small in-page search box — the one place it is drawn. */
const SIZES = {
  sm: "h-10 text-[13.5px]",
  md: "h-11 text-[14px]",
};

export const SearchField = ({
  value = "",
  onChange = () => {},
  placeholder = "Search",
  label,
  size = "md",
  id,
  className = "",
  inputClassName = "",
  ...rest
}) => (
  <div
    className={cn(
      "flex w-full items-center gap-2 rounded-[var(--radius-field)] border border-[var(--line)] bg-white px-3.5",
      "transition-colors focus-within:border-[var(--field-border-hover)]",
      SIZES[size] || SIZES.md,
      className
    )}
  >
    <span aria-hidden="true" className="flex shrink-0 text-[var(--muted)]">
      <SearchIcon size={16} />
    </span>
    <input
      id={id}
      /* type="search" gives the field its clear affordance in the browsers
         that draw one, and the right keyboard action on a phone. */
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={label}
      className={cn(
        "min-w-0 grow basis-0 border-none bg-transparent text-[var(--ink)] outline-none",
        "placeholder:text-[var(--muted)] font-sans",
        inputClassName
      )}
      {...rest}
    />
  </div>
);

export default SearchField;
